import gPhoneNumber, { PhoneNumberFormat } from 'google-libphonenumber'

function formatPhoneNumber(value?: string, countryCode: string = 'BE'): string {
  if (!value) {
    return ''
  }

  try {
    const PNF = PhoneNumberFormat
    const phoneUtil = gPhoneNumber.PhoneNumberUtil.getInstance()

    const parsedPhoneNumber = phoneUtil.parseAndKeepRawInput(value, countryCode)
    const regionCode = phoneUtil.getRegionCodeForNumber(parsedPhoneNumber)

    const isValidNumberForRegion = phoneUtil.isValidNumberForRegion(parsedPhoneNumber, regionCode)

    return isValidNumberForRegion ? phoneUtil.format(parsedPhoneNumber, PNF.INTERNATIONAL) : ''
  } catch {
    return ''
  }
}

export { formatPhoneNumber }
